<template>
  <v-tooltip bottom :max-width="width">
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-if="icontooltip"  :color="color" class="mb-1" dark  dense v-bind="attrs" v-on="on">
        {{ icon }}
      </v-icon>
      <span v-else v-bind="attrs" v-on="on">
        <slot name="tooltiptext"></slot>
      </span>

    </template>
    <span class="tooltip text-center font10 mb-1">{{ text }}</span>
  </v-tooltip>
</template>
<script>
export default {
  name: 'Tooltip',
  props: {
    text:{
      type: String
    },
    icon:{
      type: String,
      default: 'info',
    },
    color:{
      type: String,
      default: '#1b2342',
    },
    width: {
      type: String,
      default: '250px',
    },
    icontooltip:{
      type: Boolean,
      default:true
    }

  },
};
</script>
<style scoped>
.v-tooltip__content {
  color: #fff !important;
  background: #1b2342 !important;
  border-color: #1b2342 !important;
}
.tooltip {
  color: #fff !important;
  line-height: 16px;
}
.tooltip::before {
  position: absolute;
  content: '';
  top: 0;
  right: 50%;
  transform: translate(50%,-100%);
  width: 10px;
  height: 13px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 13px solid #1b2342;
}
</style>